import * as React from "react";
import SocialMediaTile from "../../Components/SocialMediaTile/SocialMediaTile";
import socialMediaItems from "../../data/socialMedia";

class Contact extends React.Component {
  createSocialMediaTile = (socialMediaItem) => {
    return (
      <SocialMediaTile
        key={socialMediaItem.id}
        socialIcon={socialMediaItem.icon}
        socialMedia={socialMediaItem.name}
        profileURL={socialMediaItem.profileURL}
      />
    );
  };

  render() {
    const fullYear = new Date().getFullYear();
    return (
      <div className="contact" id="contact">
        <div className="contact-container">
          <div className="contact-title">Contact</div>
          <div className="contact-intro">
            Now what are you waiting for? Don't even hesitate and don't even
            give it a second thought. Get in touch with me right now. We can
            meet up, have a coffee and talk shop!
          </div>
          <div className="contact-social-media">
            {socialMediaItems.map(this.createSocialMediaTile)}
          </div>
        </div>
        <div className="copyright">© {fullYear}. All rights reserved.</div>
      </div>
    );
  }
}

export default Contact;
